import { marker as T } from '@biesbjerg/ngx-translate-extract-marker';

export default {
  import_title: T('Import Pool'),

  import_label: T('Select pool to import'),
  guid_placeholder: T('Pool'),
  guid_tooltip: T('Select a pool to import.'),

  find_pools_title: T('Finding Pools'),
  find_pools_msg: T('Finding pools to import...'),

  unlock_dataset_dialog_title: T('Encrypted Datasets'),
  unlock_dataset_dialog_message: T('The imported pool contains encrypted datasets, unlock them now?'),
  unlock_dataset_dialog_button: T('Continue'),
};
